<template>
  <client-list
    :clients="clients"
    :others="othersAll"
    :all="allPhone"
    :chat-or-phone="'PHONE'"
  />
</template>

<script>
import ClientList from "../common/ClientList";
import { addNewChatAndCallMixin } from "../../mixins/addNewChatAndCallMixin";
import { mapActions } from "vuex";

export default {
  mixins: [addNewChatAndCallMixin],
  components: {
    ClientList
  },
  methods: {
    ...mapActions({
      getFormDetails: "getFormDetails" // Get form details from the server
    })
  },
  created() {
    this.getFormDetails();
  }
};
</script>

<style scoped>
section {
  margin-top: 95px;
}
</style>
